<template>
  <tr
    :class="{
      [$style.isActivationPending]: endpoint.isActivationPending
    }"
  >
    <td
      :class="$style.displayName"
      :title="endpoint.displayName"
    >
      {{ endpoint.displayName }}
    </td>
    <td>{{ endpoint.deviceType }}</td>
    <td>{{ endpoint.os }}</td>
    <td v-if="endpoint.device.uvEnabled">
      <p
        :class="{ [$style.authenticationCol]: endpoint.device.uvEnabled }"
      >
        {{ deviceEncryptionString }}
      </p>
    </td>
    <td v-else>
      {{ deviceEncryptionString }}
    </td>
    <td>{{ endpoint.device.appVersion }}</td>
    <td v-if="endpoint.device.uvEnabled">
      <p :class="{ [$style.authenticationCol]: endpoint.device.uvEnabled }">
        {{ uvAuthenticationString }}
      </p>
    </td>
    <td v-else>
      {{ uvAuthenticationString }}
    </td>
    <td>
      <IconButton
        title="Delete"
        @click="handleDelete(endpoint.id)"
      >
        <TrashIcon :class="$style.deleteIcon" />
      </IconButton>
    </td>
  </tr>
</template>
<script>
import { mapActions } from 'vuex';

// Constants
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import UserDetailsConstants from 'client/systemusers/UserDetails/constants/UserDetailsConstants';

// Components
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import IconButton from 'client/components/Buttons/IconButton.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import TrashIcon from 'public/img/icons/trash.svg?inline';

// Modules
const pushMfaUserEndpointsModule = StoreModuleMap[ItemTypeConsts.pushMfaUserEndpoints];

export default {
  name: 'JCProtectDeviceTableRow',

  components: {
    IconButton,
    TrashIcon,
  },

  props: {
    endpoint: {
      type: Object,
      default: () => ({
        device: {},
      }),
      requried: true,
    },
  },

  computed: {
    deviceEncryptionString() {
      const { uvEnabled, os } = this.endpoint.device;
      const platformSpecificOffString = os === 'ios' ? 'Off' : '-';

      return uvEnabled ? 'On' : platformSpecificOffString;
    },
    uvAuthenticationString() {
      const { uvEnabled, os } = this.endpoint.device;
      const platformSpecificString = os === 'ios' ? UserDetailsConstants.ios : UserDetailsConstants.android;

      return uvEnabled ? platformSpecificString : UserDetailsConstants.none;
    },
  },

  methods: {
    ...mapActions(pushMfaUserEndpointsModule, ['deleteDeviceEndpoint']),

    handleDelete(endpointId) {
      const componentProps = {
        headerText: 'Delete JumpCloud Protect Device',
        bodyText: 'Are you sure? If the user is required to use MFA and JumpCloud Protect Mobile Push is the only enrolled factor, deleting the user’s only device locks the user out of resources enforcing MFA.',
        continueText: 'confirm',
        handleCancel: () => ModalEventBus.close(),
        handleContinue: () => {
          ModalEventBus.close();
          this.deleteDeviceEndpoint({ userId: this.$route.params.id, endpointId });
        },
        mainActionAttention: true,
        kbLink: KbArticleUrls.jcProtectForAdmins,
        kbLinkText: 'Read the Knowledge Base',
        showClose: true,
      };

      ModalEventBus.open({
        isLargeModal: false,
        component: ConfirmationModal,
        componentProps,
      });
    },
  },
};
</script>
<style module>
tr.isActivationPending {
  color: var(--jcGrey);
}

.deleteIcon {
  width: 1.5rem;
}

.deleteIcon path:hover {
  fill: var(--jcError700);
}

.displayName {
  max-width: 15rem;
  overflow: hidden;
  padding-right: 0.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.authenticationCol {
  margin-bottom: 0;
  margin-left: 10px;
  padding-left: 4px;
  position: relative;
}

.authenticationCol::before {
  background-color: var(--jcSuccess);
  border-radius: 100%;
  content: "";
  display: block;
  height: 8px;
  left: -10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}
</style>
